// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__+Huz2","white":"Logo_white__SIWLJ","svg":"Logo_svg__37vwS","whiteSvg":"Logo_whiteSvg__ioBEU"};